import { Locale } from '../../types/localization';

export const generateLocalizationHeaders = (locale?: string) => ({
  'X-Language-Tag': locale || Locale.GERMAN_GERMANY,
});
